import {AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, QueryList, ViewChildren} from '@angular/core';
import {Formation, Question, QuestionService, TypeReponse} from '../../formation';
import {ConfirmationService} from 'primeng/components/common/api';
import {AlertService} from 'ng-jhipster';
import {TranslateService} from 'ng2-translate';
import {Editor} from 'primeng/primeng';

@Component({
    selector: 'jhi-question-component',
    templateUrl: 'question.component.html'
})
export class QuestionComponent implements OnChanges, AfterViewInit {

    @Input() formation: Formation;
    @Input() questions: Question[];
    @Output() questionsChange: EventEmitter<Question[]> = new EventEmitter();
    @Input() currentLang: string;
    @Input() disabled: boolean;
    @ViewChildren(Editor) editorList: QueryList<Editor>;

    aideQuestion: Boolean[] = [];
    typesReponses: String[] = Object.keys(TypeReponse).slice(Object.keys(TypeReponse).length / 2).filter(type => type != 'RADIO');

    constructor(
        private confirmationService: ConfirmationService,
        private questionService: QuestionService,
        private alertService: AlertService,
        private translateService: TranslateService) {
        this.translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang);
    }

    ngAfterViewInit() {
        // les <p-dialog [disabled]=true> ne fonctionnent pas, contournement ci après
        if (this.disabled) {
            this.editorList.forEach(
                editor => {
                    editor.quill.disable();
                });
        }
    }

    ngOnChanges() {
        if (this.questions && this.questions.length) {
            this.questions.forEach(question => this.aideQuestion[question.id] = question.aide != null);
        }
    }

    addQuestion() {
        if (!this.questions) {
            this.questions = [ ];
        }
        this.questions.push(this.newQuestion());
        this.questionsChange.emit(this.questions);
    }

    clearQuestion(index) {
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.formation.delete.questionComplementaire.question'),
            header: this.translateService.instant('cadensApp.formation.delete.questionComplementaire.title'),
            accept: () => {
                if (this.questions[index].id != null) {
                    this.questionService.delete(this.questions[index].id).subscribe(() => {
                        this.questions.splice(index, 1);
                        this.questionsChange.emit(this.questions);
                    }, error => {
                        this.alertService.error(error.message, null, null);
                    });
                } else {
                    this.questions.splice(index, 1);
                    this.questionsChange.emit(this.questions);
                }
            },
            reject: () => {
            }
        });
    }

    private newQuestion() {
        let q: Question = new Question();
        q.obligatoire = true;
        q.interne = true;
        q.externe = true;
        if (this.formation) {
            q.formationId = this.formation.id;
        }
        return q;
    }

    isPasDeModification() {
        if (this.disabled) {
            return this.disabled;
        }
        return null;

    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/question/question.component.ts